import axios from "axios";

const CSRF_COOKIE_NAME = "csrftoken";
const CSRF_HEADER_NAME = "X-CSRFToken";

axios.defaults.baseURL = "https://api1.proset.gr/";
// axios.defaults.baseURL = 'http://192.168.10.113:8084/'
const token = localStorage.getItem("key");
if (token != null) {
    axios.defaults.headers.Authorization = `Token ${token}`;
}

const session = axios.create({
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME,
});

export default session;
